import React, { useState } from 'react'
import Summary from './Summary';
import Measurement from './Mesurement';

const GrowthTracking = ({ _child }) => {
    const [propertyTab, setPropertyTab] = useState("Weight");
    return (
        <div>
            <div className="wrapper_cstm_tabers babydetail_tabs">
                <ul>
                    <li
                        className={propertyTab === "Weight" ? "active" : ""}
                        onClick={() => setPropertyTab("Weight")}
                    >
                        Weight
                    </li>

                    <li
                        className={propertyTab === "Height" ? "active" : ""}
                        onClick={() => setPropertyTab("Height")}
                    >
                        Height
                    </li>

                    <li
                        className={propertyTab === "Head" ? "active" : ""}
                        onClick={() => setPropertyTab("Head")}
                    >
                        Head
                    </li>

                    <li
                        className={propertyTab === "Summary" ? "active" : ""}
                        onClick={() => setPropertyTab("Summary")}
                    >
                        Summary
                    </li>
                </ul>
            </div>

            {propertyTab === "Weight" && <Measurement _child={_child} type={"WEIGHT"} />}
            {propertyTab === "Height" && <Measurement _child={_child} type={"HEIGHT"} />}
            {propertyTab === "Head" && <Measurement _child={_child} type={"HEAD"} />}
            {propertyTab === "Summary" && <Summary _child={_child} type={"HEAD"} />}

        </div>
    )
}

export default GrowthTracking